<inline-skjema>
  <form data-testid="saksskjema" [formGroup]="skjema" (ngSubmit)="lagre()" navigasjonforhindret-flash>
    @if(erAvholdt()){
      <div class="avholdt-møte">
        {{"Du redigerer innholdet i et møte som er avholdt. Vil du fortsette?"|translate}}
        <a (click)="gaaTilRedigerReferat()">{{"Klikk her for å redigere referatet/protokollen til denne saken."|translate}}</a>
      </div>
    }

    <div class="skjemainnhold">
    <fieldset class="tittel-rad">
      <div class="nummer">{{sak().nummer}}</div>

      <mat-form-field class="tittel">
        <input matInput formControlName="tittel" data-testid="tittel">
        @if (skjema.controls.tittel.hasError('maxlength')) {
          <mat-error data-testid="maxlength">{{skjema.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="ansvarlig">
        <mat-label>{{ "Saksansvarlig"|translate }}</mat-label>
        <velg-medlem [medlemmer]="gruppemedlemmer()" [skjemakontroll]="skjema.controls.ansvarlig" stil="kun-avatar" data-testid="ansvarlig"/>
      </mat-form-field>
    </fieldset>

    <fieldset class="attributter-rad">
      @if(erFlerdagsmoete()){
        <mat-form-field class="dag">
          <mat-label>{{ "Dag"|translate }}</mat-label>
          <velg-dag-fra-flerdagsmoete [skjemakontroll]="skjema.controls.dag" [moetedato]="sak().moete.dato"/>
        </mat-form-field>

        @if(visStartklokkeslettvelger){
          <mat-form-field class="startklokkeslett">
            <mat-label>{{ "Starttidspunkt dag {dag}"|translate: {dag: skjema.controls.dag.value!+1} }}</mat-label>
            <klokkeslett-velger formControlName="startklokkeslett" data-testid="starttidspunkt"/>
            <mat-icon matPrefix fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"></mat-icon>
          </mat-form-field>
        }
      }

      <mat-form-field>
        <mat-label>{{ "Varighet"|translate }}</mat-label>
        <varighet-minutter-velger [skjemakontroll]="skjema.controls.varighet" [starttidspunkt]="starttidspunkt!" data-testid="varighet"/>
        <mat-icon matPrefix fontSet="ion-ios-stopwatch-outline" class="mat-icon--ionic-ikon"></mat-icon>
      </mat-form-field>

      <mat-form-field class="sakstype">
        <mat-label>{{ "Sakstype"|translate }}</mat-label>
        <velg-sakstype [skjemakontroll]="skjema.controls.sakstype" [sakstyper]="sakstyper()"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "Tema"|translate }}</mat-label>
        <velg-tema [skjemakontroll]="skjema.controls.tema" [temaer]="temaer()"/>
      </mat-form-field>
    </fieldset>

    <mat-form-field class="beskrivelse">
      <mat-label>{{ "Saksbeskrivelse"|translate }}</mat-label>
      <riktekst-redigering [skjemakontroll]="skjema.controls.beskrivelse" [gruppeId]="sak().eiendeGruppeId" innholdBrukesIPdf="true" data-testid="beskrivelse"/>
    </mat-form-field>

    <beslutninger-skjema [skjema]="skjema.controls.beslutningsforslag" [gruppeId]="sak().eiendeGruppeId"/>

    @if(antallEndeligeBeslutninger() > 0){
      <div class="endelige-beslutninger-skjult">
        <i class="ion-ios-information-outline"></i>
        {{ "Saken har referatførte beslutning(er). Gå til protokoll fra å se disse."|translate: {antall: antallEndeligeBeslutninger()} }}
      </div>
    }
    </div>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
        {{ "Lagre"|translate }}
      </button>
      <button mat-stroked-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <div class="avstand"></div>
      <div class="sortering">
        <mat-slide-toggle [formControl]="skjema.controls.sorterEtterSakstype" [matTooltip]="sorterEtterSakstypeTips">
          {{'Sorter saker etter sakstype'|translate}}
        </mat-slide-toggle>
        @if(initiellSorterEtterSakstypeEndret){
          <mat-checkbox [formControl]="skjema.controls.huskSorterEtterSakstypeValg" matTooltip="{{'Bruk dette som standard på møter i denne gruppen'|translate}}">
            {{'Husk dette valget' | translate}}
          </mat-checkbox>
        }
      </div>
      <mat-slide-toggle [formControl]="skjema.controls.informerSaksansvarlig" matTooltip="{{'Sender epost til saksansvarlige med varsel om at de har fått ansvar for sak'|translate}}">
        {{'Informer om sakstildeling'|translate}}
      </mat-slide-toggle>
    </inline-skjema-handlinger>

  </form>
</inline-skjema>
